import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'bootstrap';
import { Select, SelectType } from '@components/atoms/Select';
import { Typography } from '@components/atoms/Typography';
import { ResultsType } from '@types';
import styles from './ResultsPageTop.module.css';

export interface ResultsPageTopProps {
    type: ResultsType;
    total: number;
    order: {
        options: { value: string; text: string }[];
        onChange: (value: string) => void;
    };
    sidebar: Collapse | null;
}

export const ResultsPageTop: FC<ResultsPageTopProps> = ({ type, total, order, sidebar }) => {
    const { t } = useTranslation();

    const translations = {
        totalProducts: t('results-container-component.total-products'),
        totalMerchants: t('results-container-component.total-merchants'),
        totalServices: t('results-container-component.total-services'),
        totalPointsServices: t('results-container-component.total-points-services'),
        filterLabel: t('results-container-component.filter.label'),
        orderByLabel: t('results-container-component.order-by.label'),
    };

    const openSidebar = () => {
        sidebar?.show();
    };

    const getTotalText: () => string = useCallback(() => {
        switch (type) {
            case ResultsType.products:
                return translations.totalProducts;
            case ResultsType.merchants:
                return translations.totalMerchants;
            case ResultsType.services:
                return translations.totalServices;
            case ResultsType.pointsServices:
                return translations.totalPointsServices;
            default:
                return '';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, t]);

    return (
        <>
            <div className="d-flex align-items-center pb-3">
                <div className={`${styles['total-results']} d-none d-lg-grid flex-grow-1 align-content-center`}>
                    <Typography classes="mb-0" fontSize="16">
                        <>
                            {getTotalText()}: {total}
                        </>
                    </Typography>
                </div>
                <div className="d-block d-lg-none flex-grow-1">
                    <button onClick={() => openSidebar()}>
                        <i className="fa-light fa-filter me-2"></i>
                        {translations.filterLabel}
                    </button>
                </div>
                {order.options.length > 0 && (
                    <div className="d-flex align-items-center">
                        <Typography classes="d-none d-lg-block text-nowrap mb-0 me-3" fontSize="16">
                            {translations.orderByLabel}
                        </Typography>
                        <div className="ms-3">
                            <Select type={SelectType.variant2} width="182px" {...order} />
                        </div>
                    </div>
                )}
            </div>
            <hr className="mt-0 mb-3" />
        </>
    );
};
